import React, { useState, useEffect } from "react";
import axios from "axios";
import { getParticipantFullName } from "../../../../../utils/participantDisplayName.js";
import API_BASE_URL from "../../../../../config/config.js";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const Regionales = ({ config }) => {
  const { idevent, idsport } = useParams();
  const [participantes, setParticipantes] = useState([]);
  const [regionMap, setRegionMap] = useState({});
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [posicion, setPosicion] = useState("");
  const [tag, setTag] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (config && config.separacionData) {
      setRegionMap(config.separacionData);
    }
  }, [config]);

  useEffect(() => {
    const getParticipantes = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/getparticipants`, {
          idevent: Number(idevent),
          idsport: Number(idsport),
          idtypephase: 1,
        });
        setParticipantes(response.data);
      } catch (error) {
        console.error("Error fetching participants:", error);
      }
    };
    if (idevent && idsport) {
      getParticipantes();
    }
  }, [idevent, idsport]);

  const regiones = {};

  participantes.forEach((participant) => {
    const regionInfo = regionMap[participant.idseparacion];
    if (regionInfo) {
      if (!regiones[regionInfo.name]) {
        regiones[regionInfo.name] = [];
      }
      regiones[regionInfo.name].push({
        ...participant,
        img_path: regionInfo.img_path,
        abrev: regionInfo.abrev,
      });
    } else {
      if (!regiones["INSTITUCIONES PARTICIPANTES"]) {
        regiones["INSTITUCIONES PARTICIPANTES"] = [];
      }
      regiones["INSTITUCIONES PARTICIPANTES"].push(participant);
    }
  });

  // Ordenar los participantes dentro de cada región según su atributo "posicion"
  Object.keys(regiones).forEach((region) => {
    regiones[region].sort((a, b) => {
      if (a.posicion === null || a.posicion === undefined) return 1;
      if (b.posicion === null || b.posicion === undefined) return -1;
      return a.posicion - b.posicion;
    });
  });

  const orderedRegions = Object.keys(regionMap).map(
    (key) => regionMap[key].name
  );
  const nonEmptyRegions = orderedRegions.filter(
    (region) => regiones[region] && regiones[region].length > 0
  );

  const isSingleRegion = nonEmptyRegions.length === 1;

  const handleRowClick = (participant) => {
    setSelectedParticipant(participant);
    setPosicion(participant.posicion || "");
    setTag(participant.tag || "");
    setIsModalOpen(true);
  };

  const handleModalClick = (e) => {
    if (e.target.classList.contains("modal-container")) {
      setIsModalOpen(false);
    }
  };

  const handleUpdate = async () => {
    try {
      await axios.patch(`${API_BASE_URL}/updateposiciontag`, {
        idevent: selectedParticipant.idevent,
        idsport: selectedParticipant.idsport,
        idtypephase: selectedParticipant.idtypephase,
        idinstitution: selectedParticipant.idinstitution,
        posicion: posicion,
        tag: tag,
      });
      setIsModalOpen(false);
      const response = await axios.post(`${API_BASE_URL}/getparticipants`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        idtypephase: 1,
      });
      setParticipantes(response.data);
      toast.success("¡Participante Actualizado Correctamente!");
    } catch (error) {
      toast.error("¡Error al Actualizar al Participante!");
      console.error("Error updating participant:", error);
    }
  };

  return (
    <div
      className={`p-4 grid gap-4 ${
        isSingleRegion
          ? "grid-cols-1 justify-center"
          : "grid-cols-1 md:grid-cols-2"
      }`}
    >
      {nonEmptyRegions.map((region) => (
        <div
          key={region}
          className={`bg-white rounded-lg shadow-md p-4 overflow-x-auto ${
            isSingleRegion ? "mx-auto max-w-4xl" : "max-w-4xl"
          }`} // Cambiado el max-w-lg a max-w-4xl para mayor ancho
        >
          <h2 className="text-center text-xl font-bold mb-2">{region}</h2>
          <table className="w-full min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                  Participante
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                  CondiciónA
                </th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-500 uppercase tracking-wider">
                  Sigla
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {regiones[region].map((participant, index) => {
                return (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(participant)}
                    className="cursor-pointer"
                  >
                    <td className="px-4 py-2 whitespace-nowrap flex items-center">
                      <img
                        src={`${participant.Institution.path_base}${participant.Institution.image_path}`}
                        alt="Logo"
                        className="w-8 h-8 rounded-full object-cover mr-2"
                      />
                      {getParticipantFullName(participant)}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {participant.tag || "N/A"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {participant.Institution.abrev}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 modal-container"
          onClick={handleModalClick}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-4">Actualizar Participante</h2>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Posición</label>
              <input
                type="number"
                value={posicion}
                onChange={(e) => setPosicion(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Tag</label>
              <input
                type="text"
                value={tag}
                onChange={(e) => setTag(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded focus:outline-none"
              />
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancelar
              </button>
              <button
                onClick={handleUpdate}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                Actualizar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Regionales;
